// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8445 ? "bc98253f" : chunkId) + "." + {"751":"c58170f976229172","3969":"1d3959d5bf8b9e28","8445":"f4500747c98d9dcd","8848":"65106ef0c2c6c697"}[chunkId] + ".js";
};